import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Cliente } from 'src/app/Models/cliente/cliente';
import { DataService } from 'src/app/Service/data.service';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { Factura } from 'src/app/Models/factura/factura';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { DetalleFactura } from 'src/app/Models/factura/detallefactura/detalle-factura';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/Service/auth.service';
import { Personal } from 'src/app/Models/personal/personal';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { Numero } from 'src/app/Models/numero/numero';
import * as moment from 'moment';


@Component({
  selector: 'app-cliente-register',
  templateUrl: './cliente-register.component.html',
  styleUrls: ['./cliente-register.component.css']
})
export class ClienteRegisterComponent implements OnInit {
  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('txtdocumento', null) txtfirt: ElementRef;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  public isShow: boolean = false;
  public pagina: number = 0;
  public formapagos: any[] = [];
  public clientes: Cliente[] = [];
  public detfactus: DetalleFactura[] = [];
  public cliente: Cliente = new Cliente();
  public factura: Factura = new Factura();
  public isEdit: boolean = false;
  public isfactura: boolean = false;
  public isdocvalid: boolean = false;
  public funcion: Function = null;
  public pagcli: any;
  public total: number = 0;
  public adddescripcion: boolean = false;
  public search = '';
  public tipodocumento = '2'
  public modal = "modal-lg";
  public pagclidlg: any;
  public showdelete: boolean = false;
  public zindex: number = 10000;
  public usuario = null;
  public isdisabled: boolean = true;
  public pagocontarjeta: boolean = false;
  public vuelto: number = 0;
  public personal: Personal = new Personal();
  public alertType: AlertType = new AlertType;
  public serie_boleta: Numero = new Numero;
  public serie_factura: Numero = new Numero;
  public listapersonal: Personal[] = [];
  public zonas: any[] = []
  submitted = false;
  constructor(private data: DataService, private route: Router, private auth: AuthService) { }


  ngOnInit() {
    this.usuario = this.auth.getCurrentUser();
  }



  public show(affterfunction: Function = null) {
    this.funcion = affterfunction;
    this.isShow = true;
    this.showTab(1);
    this.showdelete = false;
    this.factura.efectivo = this.factura.total
    this.factura.recibido = this.factura.efectivo
    this.factura.vuelto = 0
    this.factura.tarjeta = '10'
    this.factura.fec_entrega = moment(new Date()).format('YYYY-MM-DDTHH:MM')
    console.log(this.factura.fec_entrega);


    setTimeout(() => {
      this.btnshow.nativeElement.click();
      this.info.hide();
      this.getFormaPagos();
      this.GetZonasUbigeo();
      this.getlistaPersonal();
      console.log("mostrando series");
      console.log(this.serie_boleta);
      console.log(this.serie_factura);
      console.log("Mostrando personal");
      console.log(this.personal);
      console.log("Mostrando cliente");
      console.log(this.cliente);
      console.log("Mostrando factura");
      console.log(this.factura);
    }, 10);
  }


  showTab(i) {

    this.pagina = i;
    if (this.pagina == 1) { this.modal = 'modal-lg'; }
    else { this.modal = ''; }
  }



  validateFields(): boolean {
    return this.cliente.documento && this.cliente.tipodocide && this.factura.direccion !== null;
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.validateFields()) {
      console.log('Form Submitted!', this.factura);
    }
  }

  getFormaPagos() {
    this.data.GetSimple(this.data.api.mediopago).subscribe(r => this.formapagos = r)
  }

  getlistaPersonal() {
    this.data.GetSimple(this.data.api.personal).subscribe((r) => {
      this.listapersonal = r
    })
  }

  getliquidacion() {

    const datapersonal = { 'fecha': this.factura.fecha, 'idpersonal': this.factura.idvende }
    console.log(datapersonal);

    this.data.Post('getLiqGasto', datapersonal).subscribe((data) => {
      // Manejar la respuesta exitosa
      console.log('Liquidación obtenida:', data);
    },
      (error) => {
        // Manejar el error de obtener la liquidación
        console.error('Error al obtener la liquidación:', error);
        // Si no se puede obtener la liquidación, cerrar sesión y redirigir a la página de inicio de sesión
        this.usuario.idpersonal.idnivel!=2 ? this.data.notify("Se necesita crear una liquidacion.", "Liquidacion no encontrada.", this.data.alertType.info) : this.auth.logoutUser()
      }
    );

  }

  GetZonasUbigeo(){
    this.data.GetSimple(this.data.api.ubicacion).subscribe(r =>{

        this.zonas = r;
        console.log(this.zonas);
    });
}

  search_keypress(e) {

  }
  
  async GetCliente() {
    console.log("buscando cliente");
    await this.data.AsyncGetFromValue(this.data.api.cliente, 'documento', this.cliente.documento).then(async r => {
      console.log(r);

      if (r.length < 1) {
        console.log("buscando en sunat");
        await this.data.Consulta('ruc',this.cliente.documento).then(r => {
          console.log(r);
          if (r.result==1) {
            //this.personal.nombre = r.nombres + ' ' + r.apellidoPaterno + ' ' + r.apellidoMaterno
            this.cliente.nombre = r.message.razon_social
            this.cliente.tipodocide = '1'
          } else {
            this.data.notify("Cliente no encontrado, ingrese uno manualmente.", "Error", this.alertType.error);
          }
        }).catch(() => { this.data.notify("DNI invalido o no existente", 'Error', this.data.alertType.error) })
        // await this.data.ConsultaDNI(this.cliente.documento).then(r => {
        //   console.log(r);
        //   if (!r.success) {
        //     this.data.notify("Cliente no encontrado, ingrese uno manualmente.", "Error", this.alertType.error);
        //   } else {
        //     this.cliente.nombre = `${r.nombres} ${r.apellidoPaterno} ${r.apellidoMaterno}`
        //     this.cliente.tipodocide = '1'
        //   }

        // }), e => { console.log(e) };
        // await this.data.Consulta('ruc', this.cliente.documento).then(r => {
        //   console.log(r);
        //   if (r.result != 0) {
        //     if (r.message.razon_social == null) {
        //       this.data.notify("Cliente no encontrado, ingrese uno manualmente.", "Error", this.alertType.error);
        //       console.log(r.message);
        //     } else {
        //       this.cliente.nombre = r.message.razon_social
        //       this.cliente.direccion = r.message.domicilio_fiscal
        //       //this.cliente.tipodocide = this.tipodocumento
        //     }
        //   } else {
        //     console.log(r.message);
        //     this.cliente = new Cliente();
        //   }

        // }), e => { console.log(e) };
      } else {
        console.log(r);
        this.cliente = r[0];
        console.log("Tipo documento del cliente");
        console.log(this.cliente.tipodocide);
      }
    }, e => {
      console.log(e);
    })
  }

  close() {
    this.btnclose.nativeElement.click();
    setTimeout(() => { this.isShow = false; }, 1000);
    setTimeout(() => { if (this.funcion != null) { this.funcion(); } }, 10);
  }

  ValidarTipoDoc() {
    this.cliente.documento = null;
    this.cliente.nombre = null;
    this.tipodocumento != "1" ? this.isfactura = false : this.isfactura = true;

  }

  calcularEfectivo() {
    this.factura.efectivo = this.factura.total - this.factura.tarjetachq
  }

  buscarDireccion() {
    const direccion = (document.getElementById('direccion') as HTMLInputElement).value;
    const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(direccion)}`;
    window.open(url, '_blank');
  }

  ValidarDocumento() {
    var ExpReg = '^[0-9]{11}$';
    let error = "RUC debe contener 11 digitos."

    if (this.tipodocumento == "1") {
      if (this.cliente.documento.match(ExpReg) != null) {
        console.log("exito");
        this.isdocvalid = true;
      } else {
        this.alert.show(error, 0, 5000)
        this.isdocvalid = false;
        console.log(error);
      }
    } else {
      if (this.cliente.documento != undefined) {
        this.isdocvalid = true;
      } else { this.isdocvalid = false; }
    }
  }

  isDocValid() {
    return this.isdocvalid
  }

  addMetodoPago() {
    this.pagocontarjeta = true;
    this.factura.tarjetachq = this.factura.total;
    this.factura.efectivo = 0;

  }

  closeMetodoPago() {
    this.pagocontarjeta = false;
    if (this.factura.tarjetachq != 0) {
      this.factura.efectivo = this.factura.total
    }
  }

  CalcularVuelto() {
    document.getElementById("inp_vuelto").setAttribute("style", "border: 1px solid red;");
    if (this.pagocontarjeta == false && this.factura.recibido > this.factura.efectivo && this.factura.efectivo != 0) {
      this.factura.vuelto = (+(this.factura.recibido - this.factura.efectivo).toFixed(2));
      document.getElementById("inp_vuelto").setAttribute("style", "");
    }
  }
  // addFormaPago(){
  //   let formapago = {formadepago:'efectivo',codformapago:'0', monto:0,mostrar:true}
  //   this.formasPago.push(formapago);
  // }

  isCliente() {
    if (this.pagocontarjeta == false) {
      let res = this.cliente.nombre != undefined && this.cliente.documento != undefined && this.cliente.tipodocide != undefined && this.cliente.direccion != undefined
        && this.factura.total != 0 && this.factura.efectivo != 0 && this.factura.recibido != 0 && this.factura.vuelto != undefined
      return res

    } else {
      return this.cliente.nombre != undefined && this.cliente.documento != undefined && this.cliente.tipodocide != undefined && this.cliente.direccion != undefined
        && this.factura.total != 0 && this.factura.tarjeta != undefined && this.factura.tarjetachq != 0 && this.factura.voucher != undefined
    }

  }



  async prepara_data() {
    this.factura.idcliente = this.cliente.idcliente;
    this.factura.apellidos = this.cliente.nombre;
    this.factura.direccion = this.cliente.direccion;
    this.factura.ruc = this.cliente.documento;
    this.factura.tip_iden = this.cliente.tipodocide;
    this.usuario.idpersonal.idnivel!=2 ? this.factura.entrega = 0 : this.factura.entrega = 1
    if (this.factura.tarjeta === '13') {
      this.factura.estado = 'EMI'

    } else {
      this.factura.estado = 'CAN'
      this.factura.fvcto = null
      this.factura.diasletras = null
    }

    this.factura.clasepago = 'CON'
    console.log("preparando factura");
    console.log(this.factura);
    console.log(this.factura.ruc);


  }

  async ActualizarCliente() {
    console.log("buscando cliente");
    await this.data.AsyncPut(this.data.api.cliente, this.cliente.idcliente, this.cliente).then(async r => {
      console.log(r);
    }, e => {
      console.log(e);
    })
  }

  async getPersonal() {
    await this.data.AsyncGetFromValue(this.data.api.personal, 'idusuario', this.usuario.id).then(r => {
      console.log(r);
      this.personal = r[0];
      console.log("Obteniendo personal", this.personal);
    });
  }

  async GuardarDetFactu() {
    this.detfactus.forEach(async detfactura => {
      await this.data.AsyncPost(this.data.api.detfactura, detfactura).then(async (r) => {
        if (r.length > 0) {
          console.log("detalles guardados");
        }
      }).catch(async (e) => { console.log(e); this.info.show(e, 0); });

    });

  }

  show_ticket(idfactura: any) {
    switch (this.tipodocumento) {
      case '0':
        this.route.navigateByUrl('/printer/boleta/' + idfactura);
        break;
      case '1':
        this.route.navigateByUrl('/printer/factura/' + idfactura);
        break;
      case '2':
        this.route.navigateByUrl('/printer/pedido/' + idfactura);
        break;
      default:
        break;
    }


  }


  async GuardarNumero(idnumero: any, numero: Numero) {
    numero.ultimo = (+numero.ultimo + 1)
    await this.data.AsyncPut(this.data.api.numero, idnumero, numero).then(r => {
      if (r.status != "success") {
        console.log("Ejecutando GuardarNumero");
        console.log(r);
      }
    }).catch(e => console.log(e))
  }

  async GuardarFactura() {

    //this.factura.idsucursal = 1
    this.factura.idsucursal = parseInt(this.data.getSucursalId())
    switch (this.tipodocumento) {
      case '0':
        this.factura.documen = 'BOL'
        this.factura.serie = this.serie_boleta.serie
        this.factura.numero = (+this.serie_boleta.ultimo + 1)
        await this.GuardarNumero(this.serie_boleta.idnumero, this.serie_boleta)
        break;
      case '1':
        this.factura.documen = 'FAC'
        this.factura.serie = this.serie_factura.serie
        this.factura.numero = (+this.serie_factura.ultimo + 1)
        await this.GuardarNumero(this.serie_factura.idnumero, this.serie_factura)
        break;
      case '2':
        this.factura.documen = 'PED'
        const seriepedido = await this.data.GetSeriePedido() as Numero
        console.log("Obteniendo series:",seriepedido);
        this.factura.serie = seriepedido.serie
        this.factura.numero = seriepedido.ultimo
        await this.GuardarNumero(seriepedido.idnumero, seriepedido)
        break;
      default:
        break;
    }

    if (this.detfactus.length < 1) {
      this.data.notify("No hay productos en la lista.", 'Error', 0);
    } else {
      let idfactu: any = ''
      await this.data.AsyncPost(this.data.api.factura, this.factura).then(async (r) => {
        if (r.idfactura != null && r.idfactura != undefined) {
          if (r.idfactura != undefined) {
            idfactu = r.idfactura
            /* registrar detalle */
            let item: number = 1;
            for (let det of this.detfactus) {
              det.idfactura = r.idfactura;
              console.log(det.idfactura);
              console.log(det);

              // det.item = item+"";
              await this.data.AsyncPost(this.data.api.detfactura, det).then(x => {

                console.log(x);
              }).catch(e => { console.log(e); })
              // item++;
            }

          } else {
            this.data.notify("error", 'Error de registro', 0);
          }
          this.info.show("Guardado con exito", 0);
        } else {
          console.log(r);
        }
      }).catch(e => { console.log(e); this.info.show(e, 0) }).finally(() => { this.close(); this.show_ticket(idfactu); })
    }

  }

  async Save() {
    await this.prepara_data().then(async () => {
      let idcliente = this.cliente.idcliente
      this.loading.show('Guardando datos');
      if (idcliente != null && idcliente != undefined && idcliente != '') {
        console.log("guardando factura");
        this.GuardarFactura();
        this.ActualizarCliente();
      } else {
        await this.data.AsyncPost(this.data.api.cliente, this.cliente).then(async (r) => {
          try {
            if (r.idcliente) {
              this.cliente = r;
              this.factura.idcliente = this.cliente.idcliente
            }
          } catch (error) { 
            console.log(error);
            
          }
        }).then(r => { this.GuardarFactura() }).catch(e => { console.log(e) })
      }

      this.loading.hide();
    });

  }


}